import VueI18n from 'vue-i18n'
import Vue from 'vue'
import messagesNl from '../lang/nl'
import messagesEn from '../lang/en-US'
import elementNL from 'element-ui/lib/locale/lang/nl'
import elementEN from 'element-ui/lib/locale/lang/en'
import elementLocale from 'element-ui/lib/locale'
Vue.use(VueI18n)

export default function setLocale(lang) {
  if (lang === 'nl') {
    elementLocale.use(elementNL)
  } else {
    elementLocale.use(elementEN)
  }
  const i18n = new VueI18n({
    locale: 'en',
    messages: {
      nl: messagesNl,
      en: messagesEn
    }
  })
  i18n.locale = lang
  return i18n
}
